/* start - flights_web_fd_baggage_transparency */
import React from "react";
import { UIFlightData } from "@flights/types";
import useDetailedBaggageInfoController from "./useDetailedBaggageInfo.controller";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { SVG } from "@bookingcom/bui-react/components/Icon/Icon.types";
import { BaggageItem } from "../../../../../IncludedBaggage/components/BaggageItem";
import Frame from "../../../../../Frame";
import BaggagePolicies from "../../../../../BaggagePolicies";

const useDetailedBaggageInfo = (flight: UIFlightData) => {
  const {
    header,
    subheader,
    getSegmentTitle,
    getLuggageData,
    hasInfantWithNoBaggageAllowance,
    baggagePolicies,
    getLuggageTypeData,
    infantMissingLuggageData
  } = useDetailedBaggageInfoController(flight);

  return {
    header,
    subheader,
    content: (
      <Stack gap={2}>
        {flight.includedProducts?.segments.map((segment, i) => {
          const differBySegment = !flight.includedProducts?.areAllSegmentsIdentical;

          return (
            <Stack key={i} gap={2} attributes={{ "data-testid": `included_baggage_${i}` }}>
              {differBySegment && <Text variant="strong_2">{getSegmentTitle(i)}</Text>}

              {getLuggageData({ segment, differBySegment }).map((l) => {
                if (!l) return undefined;

                if (l.includedBaggage) {
                  return <BaggageItem key={l.type} luggage={l.includedBaggage} />;
                }

                if (!l.includedBaggage) {
                  const { icon, text } = getLuggageTypeData({ luggageType: l.type, perSegment: l.differBySegment });
                  return <BaggageItemDisplay key={l.type} icon={icon} text={text} />;
                }

                return undefined;
              })}
            </Stack>
          );
        })}

        {hasInfantWithNoBaggageAllowance && (
          <BaggageItemDisplay icon={infantMissingLuggageData.icon} text={infantMissingLuggageData.text} />
        )}

        {baggagePolicies && (
          <Frame>
            <BaggagePolicies baggagePolicies={baggagePolicies} />
          </Frame>
        )}
      </Stack>
    )
  };
};

const BaggageItemDisplay = ({ icon, text }: { icon: SVG; text: string }) => (
  <Stack gap={4} direction="row" grow={true} alignItems="start">
    <Icon svg={icon} size="large" color="neutral_alt" />
    <Stack.Item grow={true}>
      <Text variant="body_2" color="neutral_alt">
        {text}
      </Text>
    </Stack.Item>
  </Stack>
);

export default useDetailedBaggageInfo;
/* end - flights_web_fd_baggage_transparency */
